import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// utils
import { isColorLight } from 'utils/tree'

export const OwnedByInfo = styled.div`
  display: flex;
  gap: 6px;
  font-size: 12px;
  align-items: center;

  > div {
    height: 20px;
    width: 20px;
    font-size: 10px;
    border: none !important;
    box-shadow: none !important;
  }
`

export const ColoredValue = styled.div<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  padding: 8px;
  border-radius: 6px;
  color: ${({ $color }) => (isColorLight($color) ? colors.black : colors.white)};
`

export const Link = styled.a`
  font-size: 12px;
`
